import { Box, Tooltip, Typography, type TypographyProps } from "@mui/material";
import type { ReactElement, ReactNode } from "react";

interface TitleSubTitleProps {
  title?: ReactNode;
  subTitle?: ReactNode;
  // These remain strings for compatibility with the existing wrapper components.
  titleVariant?: string;
  subTitleVariant?: string;
  titleColor?: string;
  subTitleColor?: string;
  toolTipIcon?: ReactElement;
  toolTipText?: NonNullable<ReactNode>;
  titleId?: string;
}

const TitleSubTitle = ({
  title = "",
  subTitle = "",
  titleVariant,
  subTitleVariant,
  titleColor = "",
  subTitleColor = "",
  // eslint-disable-next-line react/jsx-no-useless-fragment
  toolTipIcon = <></>,
  toolTipText = "",
  // Lets a caller reference the rendered title from an input's aria-labelledby.
  titleId,
}: TitleSubTitleProps) => {
  return (
    <Box>
      {title && (
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography
            id={titleId}
            variant={titleVariant as TypographyProps["variant"]}
            sx={{
              wordBreak: "break-word",
            }}>
            {title}
          </Typography>
          {/* <XTypography variant={titleVariant} label={title} /> */}
          <Tooltip title={toolTipText} placement='top'>
            {toolTipIcon}
          </Tooltip>
        </Box>
      )}
      {subTitle && (
        <Box>
          <Typography
            variant={subTitleVariant as TypographyProps["variant"]}
            sx={{
              wordBreak: "break-word",
            }}>
            {subTitle}
          </Typography>
          {/* <XTypography variant={subTitleVariant} label={subTitle} /> */}
        </Box>
      )}
    </Box>
  );
};
export default TitleSubTitle;
